import { BRAND } from "constants/brand";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import { CSSTransition } from "react-transition-group";
import { Ring } from "@uiball/loaders";
import { useRef } from "react";
import "./citySettingsModal.scss";

/** Shared city modal shell with the same layout as the wallet modal. */
const CitySettingsModal = ({
    show,
    close,
    region,
    title,
    loading,
    onSubmit,
    submitLabel = "حفظ الإعدادات",
    children,
}) => {
    const nodeRef = useRef();

    return (
        <div className={`model ${show ? "model-show" : ""}`} onClick={close}>
            <CSSTransition
                mountOnEnter
                unmountOnExit
                nodeRef={nodeRef}
                in={show}
                timeout={400}
                classNames="show"
            >
                <div
                    className="addItem city-settings-modal"
                    ref={nodeRef}
                    onClick={(event) => event.stopPropagation()}
                >
                    {loading ? (
                        <div className="loading-spinner center">
                            <Ring size={40} lineWeight={5} speed={2} color={BRAND} />
                        </div>
                    ) : null}
                    <div className="head center">
                        <h5>
                            {title} — {region?.name}
                        </h5>
                        <button
                            type="button"
                            className="city-settings-modal__close"
                            onClick={close}
                        >
                            <FontAwesomeIcon icon={faClose} />
                        </button>
                    </div>
                    <Form className="form" onSubmit={onSubmit}>
                        {children}
                        <div className="buttons">
                            <button className="cancel" onClick={close} type="button">
                                إلغاء
                            </button>
                            <button className="button" type="submit" disabled={loading}>
                                {loading ? "جاري الحفظ..." : submitLabel}
                            </button>
                        </div>
                    </Form>
                </div>
            </CSSTransition>
        </div>
    );
};

export default CitySettingsModal;
